import React from 'react';
import { Radio, Select } from 'antd';
import { useSelector } from 'react-redux';

export interface AssetInfo {
  assertName?: string;
  serialNumber?: string;
  isHandled?: boolean;
  dateOfGet?: string;
  dateOfHandle?: string;
}

export interface EmployeeAssertInfo {
  assertType?: string | null;
  processor?: string;
  ram?: string;
  ssd?: string;
  graphicCard?: string;
  os?: string;
}

export interface EmployeeDetails {
  employeeAssertInfo?: EmployeeAssertInfo;
  deviceType?: string | null;
  otherPeripherals?: string;
  assetInfoList?: AssetInfo[];
}

export interface RootState {
  employee?: {
    employeeDetails?: EmployeeDetails;
  };
}

const UserEmployeAssets = () => {

  const employeeDetails = useSelector((state: RootState) => state?.employee?.employeeDetails);
  const assetConfig = [
    { "label": "Basic", value: 'Basic' },
    { "label": "Intermediate", value: 'Intermediate' },
    { "label": "Advanced", value: 'Advanced' }
  ]
  const assetType = [
    { "label": "Laptop", value: 'Laptop' },
    { "label": "Desktop", value: 'Desktop' },
  ];

  return (
    <div className='salary_details font-rubik flex flex-col' style={{ height: '100%' }}>
      <div className="employee-assets mt-5 flex-1 overflow-y-auto pb-4">
        <div className="configuration-section mb-8 2xl:p-6 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">Configuration Details</h3>

          <div className="flex flex-col space-y-6">
            <div className="flex items-center box">
              <div className="w-48 flex-shrink-0">
                <label className='font-rubik text-gray-700 font-medium'>Configuration Type</label>
              </div>
              <div className="flex-1 user-inputs-disabled">
                <Select
                  disabled={true}
                  className='font-rubik w-full max-w-xs !cursor-not-allowed'
                  value={employeeDetails?.employeeAssertInfo?.assertType !== null ? employeeDetails?.employeeAssertInfo?.assertType : 'Basic'}
                  options={assetConfig.map(option => ({ label: option.label, value: option.value }))}
                />
              </div>
            </div>


            {employeeDetails?.employeeAssertInfo && (
              <div className="bg-gray-50 rounded-md p-4">
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>
                      Processor
                    </label>

                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.processor || '-'}
                    </p>
                  </div>


                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>RAM</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.ram || '-'}
                    </p>
                  </div>

                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>SSD</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.ssd || '-'}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>Graphics Card</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.graphicCard || '-'}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <label className='font-rubik text-xs sm:text-sm text-gray-500 uppercase tracking-wider'>OS</label>
                    <p className='font-rubik text-gray-800 font-medium'>
                      {employeeDetails?.employeeAssertInfo?.os || '-'}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Card 1: Device Information */}
        <div className="device-section device-type-box p-6 bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
          <h3 className="text-lg font-semibold text-gray-800 mb-6 pb-2 border-b border-gray-200">Device Information</h3>
          <div className="flex flex-col space-y-5">
            <div className="flex items-center label-row">
              <div className="w-40 flex-shrink-0 label-box">
                <label className='font-rubik text-gray-700 font-medium'>Device Type</label>
              </div>
              <div>
                <Radio.Group
                  className='font-rubik'
                  name="deviceType"
                  disabled={true}
                  value={employeeDetails?.deviceType !== null ? employeeDetails?.deviceType : 'Laptop'}
                  options={assetType}
                />
              </div>
            </div>
            <div className="flex items-center label-row">
              <div className="w-40 flex-shrink-0 label-box">
                <label className='font-rubik text-gray-700 font-medium'>Other Peripherals</label>
              </div>
              <p className='font-rubik text-gray-800 font-medium'>
                {employeeDetails?.otherPeripherals !== "" ? employeeDetails?.otherPeripherals : 'N/A'}
              </p>
            </div>
          </div>
        </div>


        {employeeDetails?.assetInfoList && employeeDetails.assetInfoList.length > 0 && (
          <div className="p-6 bg-white rounded-lg border border-gray-200 shadow-sm mb-4">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">External Assets</h3>
            <div className="overflow-x-auto">
              <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: '800px', tableLayout: 'fixed' }}>
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className='font-rubik text-sm text-gray-500 font-medium text-left pb-3 w-[20%]'>Name</th>
                    <th className='font-rubik text-sm text-gray-500 font-medium text-left pb-3 w-[20%]'>Serial No.</th>
                    <th className='font-rubik text-sm text-gray-500 font-medium text-left pb-3 w-[30%]'>Status</th>
                    <th className='font-rubik text-sm text-gray-500 font-medium text-left pb-3 w-[15%]'>Date of Assign</th>
                    <th className='font-rubik text-sm text-gray-500 font-medium text-left pb-3 w-[15%]'>Date of Return</th>
                  </tr>
                </thead>
                <tbody>
                  {employeeDetails.assetInfoList.map((asset: AssetInfo, index: number) => (
                    <tr key={index} className="border-b border-gray-100">
                      <td className='font-rubik text-gray-800 font-medium py-3 pr-4 truncate'>{asset.assertName || '-'}</td>
                      <td className='font-rubik text-gray-800 font-medium py-3 pr-4 truncate'>{asset.serialNumber || '-'}</td>
                      <td className='py-3 pr-4'>
                        <Radio.Group disabled value={asset.isHandled}>
                          <Radio value={false}><span className='font-rubik text-gray-800'>Assigned</span></Radio>
                          <Radio value={true}><span className='font-rubik text-gray-800'>Returned</span></Radio>
                        </Radio.Group>
                      </td>
                      <td className='font-rubik text-gray-800 font-medium py-3 pr-4 whitespace-nowrap'>
                        {asset.dateOfGet ? new Date(asset.dateOfGet).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}
                      </td>
                      <td className='font-rubik text-gray-800 font-medium py-3 pr-4 whitespace-nowrap'>
                        {asset.dateOfHandle ? new Date(asset.dateOfHandle).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div >
  )
}

export default UserEmployeAssets
